<div class="flex flex-row w-full h-full">
  <flx-nav-menu
    [items]="navMenuItems()"
    [userAccessRights]="userAccessRights()"
    [permissions]="permissions()"
    [heading]="isOrganizationArea() ? 'Organization settings' : ''"
    class="w-[290px] grow-0 shrink-0 shadow-[0_0_70px_0_rgba(22,52,98,0.05)]"
  />

  <div class="main-container flex flex-row items-start w-full overflow-y-auto">
    <div class="flex flex-col w-full h-full p-10 overflow-y-auto">
      <div>
        @if (
          someComponentsAreDown() &&
          !platformStatusService.notificationDismissed() &&
          canReadPlatformStatus()
        ) {
          <flx-message
            class="mb-8 w-full bg-orange-50"
            type="warning"
            layout="row"
            display="border"
          >
            <div class="flex flex-row items-center w-full text-base">
              @if (someComponentsAreDown) {
                <div>{{ firstDownComponent() }} component is down. Check details</div>
              } @else {
                <div>Several components are down. Check details</div>
              }

              <a
                class="text-blue-500 ml-1"
                routerLink="platform-status"
              >
                here
              </a>
              <flx-icon
                (click)="platformStatusService.dismissNotification()"
                name="close"
                class="cursor-pointer w-4 h-4 ml-auto text-yellow-400"
              />
            </div>
          </flx-message>
        }
      </div>
      <router-outlet />
    </div>
  </div>
</div>
